import { onChatwootEvent } from '@/composables/useChatwootRealtime'
import { translateMessageContent } from '@/services/chatwootRealtimeTranslator'
import type { ChatMessage } from '@/types/chat'

// ── Fase 5 do plano de tempo real (docs/planos/PLANO-REALTIME-ACTIONCABLE.md) ──
// Mensagens enviadas/recebidas na conversa ABERTA na tela, em tempo real —
// mesma conexão/tradução das Fases 0-3, só um consumidor novo. Não substitui
// o poll de 8s que ConvDrawer/FloatChatWindow/MobileView já têm — ele
// continua como rede de segurança (mesma filosofia híbrida do resto do
// plano), inclusive pra cobrir a limitação de inbox/admin descoberta na
// Fase 3 (se o evento não chegar pra esse agente, o poll ainda cobre).

/**
 * Registra um listener que só dispara pra mensagens de UMA conversa
 * específica (a que está aberta na tela). Devolve a função de cancelamento —
 * cada view precisa chamar isso ao trocar/fechar a conversa aberta, senão o
 * listener antigo continua registrado apontando pro convId errado.
 */
export function onConversationMessage(convId: number, cb: (message: ChatMessage) => void): () => void {
  return onChatwootEvent(evt => {
    const translated = translateMessageContent(evt)
    if (translated && translated.conversationId === convId) {
      // eslint-disable-next-line no-console -- diagnóstico temporário da Fase 5, mesmo padrão usado nas fases anteriores
      console.debug('[MessageRealtime] gatilho de refetch pra conversa aberta', convId, translated.message.id)
      cb(translated.message)
    }
  })
}
